/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "firebase/database"

// Load mermaid from CDN and render diagrams
export const onRouteUpdate = () => {
  if (typeof window !== "undefined") {
    // Check if mermaid script is already loaded
    if (!window.mermaid && !document.getElementById("mermaid-script")) {
      const script = document.createElement("script")
      script.id = "mermaid-script"
      script.src = "https://cdn.jsdelivr.net/npm/mermaid@9/dist/mermaid.min.js"
      script.async = true
      script.onload = () => {
        console.log("Mermaid loaded from CDN")
        setTimeout(() => initializeMermaid(), 100)
      }
      document.head.appendChild(script)
    } else if (window.mermaid) {
      // Mermaid already loaded, just render
      setTimeout(() => initializeMermaid(), 100)
    }
  }
}

function initializeMermaid() {
  if (!window.mermaid) {
    console.error("Mermaid not loaded")
    return
  }

  console.log("Initializing mermaid...")

  window.mermaid.initialize({
    startOnLoad: false,
    theme: "default",
    securityLevel: "loose",
  })

  // Try multiple selectors to find mermaid code blocks
  const selectors = [
    "pre code.language-mermaid",
    "pre code[class*='mermaid']",
    "pre code[class*='language-mermaid']",
    ".language-mermaid",
  ]

  let mermaidBlocks = []
  for (const selector of selectors) {
    const blocks = document.querySelectorAll(selector)
    if (blocks.length > 0) {
      console.log(
        `Found ${blocks.length} mermaid blocks with selector: ${selector}`
      )
      mermaidBlocks = Array.from(blocks)
      break
    }
  }

  if (mermaidBlocks.length === 0) {
    console.log("No mermaid blocks found, checking all code blocks...")
    const allCodeBlocks = document.querySelectorAll("pre code")
    console.log(`Total code blocks: ${allCodeBlocks.length}`)
    allCodeBlocks.forEach((block, i) => {
      console.log(
        `Block ${i}: class="${
          block.className
        }", content preview: ${block.textContent.substring(0, 50)}`
      )
      if (
        block.textContent.trim().startsWith("graph ") ||
        block.textContent.trim().startsWith("sequenceDiagram") ||
        block.textContent.trim().startsWith("flowchart")
      ) {
        mermaidBlocks.push(block)
      }
    })
    console.log(`Found ${mermaidBlocks.length} mermaid blocks by content`)
  }

  if (mermaidBlocks.length > 0) {
    mermaidBlocks.forEach((block, index) => {
      // Check if already rendered
      const parent = block.parentElement
      if (parent && !parent.hasAttribute("data-mermaid-rendered")) {
        const graphDefinition = block.textContent

        console.log(`Rendering mermaid diagram ${index + 1}`)

        // Create a div to render the mermaid diagram
        const mermaidDiv = document.createElement("div")
        mermaidDiv.className = "mermaid"
        mermaidDiv.textContent = graphDefinition
        mermaidDiv.setAttribute("data-mermaid-index", index)

        // Replace the code block with the mermaid div
        parent.replaceWith(mermaidDiv)
        parent.setAttribute("data-mermaid-rendered", "true")
      }
    })

    // Render all mermaid diagrams
    try {
      const diagrams = document.querySelectorAll(".mermaid[data-mermaid-index]")
      console.log(`Attempting to render ${diagrams.length} diagrams`)
      window.mermaid.init(undefined, diagrams)
      console.log("Mermaid diagrams rendered successfully")
    } catch (err) {
      console.error("Failed to render mermaid diagrams:", err)
    }
  } else {
    console.log("No mermaid code blocks found on this page")
  }
}
